import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';

class TranslationStoreClass extends ReduceStore {
    getInitialState() {
        return {};
    }

    reduce(state, { source, action }) {
        if (source === 'TRANSLATION_ACTION') {
            switch (action.type) {
            case 'UPDATE_TRANSLATIONS':
                Object.assign(state, action.payload);
                this.__emitChange();
                break;
            }
        }

        return state;
    }
}

const TranslationStore = new TranslationStoreClass(Dispatcher);
export default TranslationStore;
